module.exports = __webpack_public_path__ + "img/roadmap-overlay.40795387.png";